export { HotPepper, HotPepperGrey } from './Icons';
